import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { MdOutlineStickyNote2 } from 'react-icons/md'
import Button from 'components/Button'

export default function OfferNote({ note, sender }: { note: string; sender: JSX.Element }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        className="inline-flex items-center p-2 border border-transparent rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 sm:text-gray-500 sm:hover:text-gray-700 dark:bg-transparent dark:text-gray-400 dark:sm:text-gray-400 dark:sm:hover:text-gray-300 dark:focus:ring-offset-gray-850"
        onClick={() => setOpen(true)}
      >
        <MdOutlineStickyNote2 className="h-6 w-6 sm:h-5 sm:w-5" aria-hidden="true" />
      </button>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="fixed z-[60] inset-0 overflow-y-auto" onClose={setOpen}>
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity dark:bg-black/75" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all w-full max-w-sm sm:my-8 sm:p-6 dark:bg-gray-900">
                    <div>
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-50 dark:bg-gray-300/10">
                        <MdOutlineStickyNote2
                          className="h-6 w-6 text-gray-600 dark:text-gray-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="mt-3 text-center sm:mt-5">
                        <div className="flex justify-center">{sender}</div>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500 dark:text-gray-100">{note}</p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6">
                      <Button onClick={() => setOpen(false)} className="w-full">
                        Close
                      </Button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}
